export default __webpack_public_path__ + "static/3-3e769df282a854ab619814c1fb90d550.jpeg";